import Dialog from "../../1. Core/Controls/Dialog/Dialog";
import { Collection } from "../types";
import TextField from "../../1. Core/Controls/TextField/TextField";
import NumField from "../../1. Core/Controls/TextField/NumField";
import { ServerAPI } from "../../1. Core/ServerAPI";
import DateInput from "../../1. Core/Controls/DateInput/DateInput";
import ImageTextField from "../../1. Core/Controls/TextField/ImageTextField";
import Select from "../../1. Core/Controls/Select/Select";

let moment = require('moment');

export default class EditCollectionDialog extends Dialog {
    private _Collection: Collection;
    private _startAt: DateInput;
    private _endAt: DateInput;
    private _completionGift: TextField;
    private _backgroundAsset: ImageTextField;
    // New fields
    private _nameRu: TextField;
    private _nameEn: TextField;
    private _nameEs: TextField;
    private _namePt: TextField;
    private _backgroundAssetBanner: ImageTextField;
    private _rewardCoins: NumField;
    private _rewardDiamonds: NumField;
    private _rewardAvatarCategory: Select;
    private _rewardAvatarLevel: Select;
    private _countCardGoldPackageCard: NumField;

    constructor(props: any) {
        super(props);
    }

    _initFields(settings: object) {
        this._Collection = {} as Collection;
        super._initFields(settings);
        this._Mode = 'FullHeight';
        this._Caption = 'Collection Editor';
        this._CloseOnFrameMouseDown = true;
        this._ShowHeader = true;
        this._ShowCloseButton = true;
        this._OkRK = 'Save'
        this._AutoDestroy = true;
    }

    _render() {
        super._render();

        this._startAt = new DateInput({
            ParentNode: this._contentNode,
            FloatingLabel: 'Start at'
        });

        this._endAt = new DateInput({
            ParentNode: this._contentNode,
            FloatingLabel: 'End at'
        });

        this._completionGift = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Подарок за выполнение (completion_gift)'
        });

        this._backgroundAsset = new ImageTextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Фон (background_asset)'
        });

        // New inputs
        this._nameRu = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Name (RU)'
        });

        this._nameEn = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Name (EN)'
        });
        this._nameEs = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Name (ES)'
        });
        this._namePt = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Name (PT)'
        });

        this._backgroundAssetBanner = new ImageTextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Banner background image (background_asset_banner)'
        });

        this._rewardCoins = new NumField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Reward Coins'
        });

        this._rewardDiamonds = new NumField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Reward Diamonds'
        });

        this._rewardAvatarCategory = new Select({
            ParentNode: this._contentNode,
            FloatingLabel: 'Reward Avatar Category',
            Items: [
                {Content: '— Any —', Value: null},
                {Content: 'Boxers', Value: 'Boxers'},
                {Content: 'Ankle Support', Value: 'AnkleSupport'},
                {Content: 'Gloves', Value: 'Gloves'},
                {Content: 'Training', Value: 'Training'},
                {Content: 'Equipment', Value: 'Equipment'},
                {Content: 'Sports Nutrition', Value: 'SportsNutrition'},
            ]
        });

        this._rewardAvatarLevel = new Select({
            ParentNode: this._contentNode,
            FloatingLabel: 'Reward Avatar Level',
            Items: [
                {Content: '— None —', Value: null},
                {Content: 'Basic', Value: 'basic'},
                {Content: 'Pro', Value: 'pro'},
                {Content: 'Epic', Value: 'epic'},
            ]
        });

        this._countCardGoldPackageCard = new NumField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Count Card Gold Package Card'
        });

        this.refresh();
    }

    async refresh() {
        this._startAt.setValue(this._Collection.start_at ? moment(this._Collection.start_at).toDate() : null);
        this._endAt.setValue(this._Collection.end_at ? moment(this._Collection.end_at).toDate() : null);

        this._completionGift.setValue(this._Collection.completion_gift);
        this._backgroundAsset.setValue(this._Collection.background_asset);
        // New fields
        this._nameRu.setValue(this._Collection.name_ru || '');
        this._nameEn.setValue(this._Collection.name_en || '');
        this._nameEs.setValue(this._Collection.name_es || '');
        this._namePt.setValue(this._Collection.name_pt || '');
        this._backgroundAssetBanner.setValue(this._Collection.background_asset_banner || '');
        this._rewardCoins.setValue(this._Collection.reward_coins);
        this._rewardDiamonds.setValue(this._Collection.reward_diamonds);
        this._rewardAvatarCategory.setValue(this._Collection.reward_avatar_category_key || null);
        this._rewardAvatarLevel.setValue(this._Collection.reward_avatar_item_level || null);
        this._countCardGoldPackageCard.setValue(this._Collection.count_card_gold_package_card);
    }

    async _onOkButtonClick() {
        this._Collection.start_at = this._startAt.getValue();
        this._Collection.end_at = this._endAt.getValue();
        this._Collection.completion_gift = this._completionGift.getValue();
        this._Collection.background_asset = this._backgroundAsset.getValue();
        // New fields
        this._Collection.name_ru = this._nameRu.getValue();
        this._Collection.name_en = this._nameEn.getValue();
        this._Collection.name_es = this._nameEs.getValue();
        this._Collection.name_pt = this._namePt.getValue();
        this._Collection.background_asset_banner = this._backgroundAssetBanner.getValue();
        this._Collection.reward_coins = this._rewardCoins.getValue() ? Number(this._rewardCoins.getValue()) : null;
        this._Collection.reward_diamonds = this._rewardDiamonds.getValue() ? Number(this._rewardDiamonds.getValue()) : null;
        this._Collection.reward_avatar_category_key = this._rewardAvatarCategory.getValue() || null;
        this._Collection.reward_avatar_item_level = this._rewardAvatarLevel.getValue() || null;
        this._Collection.count_card_gold_package_card = this._countCardGoldPackageCard.getValue() ? Number(this._countCardGoldPackageCard.getValue()) : null;

        if (this._Collection.id) {
            await ServerAPI.put(`/fantasy/card-collections/collections/${this._Collection.id}`, this._Collection);
        } else {
            await ServerAPI.post(`/fantasy/card-collections/collections`, this._Collection);
        }

        this.EvOkButtonClick.fire(this);
        this.hide();
    }
}